export const MessageCategoryTabs = {
	ALL: 'ALL',
	PRIVATE: 'PRIVATE',
	GROUP: 'GROUP',
};
